import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, } from '../../../../../helpers/custom-prop-types';
import RecommendationSliderTemplateItems from './RecommendationSliderTemplateItems';
const RecommendationSliderTemplate = (props) => {
    const { isLoading, items, onClick } = props;
    if (!isLoading && items.length === 0) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: 'l-container l-pickup' }, { children: _jsxs("div", Object.assign({ className: 'l-container-12 load-container' }, { children: [_jsxs("h2", Object.assign({ className: 'contents-title' }, { children: ["\u3053\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u3092\u898B\u305F\u65B9\u306F\u3001", _jsx("br", { className: 'x-small-larger-hide' }), "\u6B21\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E8B\u4F8B\u3082\u898B\u3066\u3044\u307E\u3059"] })), _jsx(RecommendationSliderTemplateItems, { isLoading: isLoading, items: items, onClick: onClick })] })) })));
};
RecommendationSliderTemplate.propTypes = {
    isLoading: propBool().isRequired,
    items: propArrayShape().isRequired,
    onClick: propFunc(),
};
RecommendationSliderTemplate.defaultProps = {
    onClick: null,
};
export default RecommendationSliderTemplate;
